<script lang="ts" setup>
import { computed } from 'vue';

type LayoutValue = {
  display?: string;
  cols?: number[];
};

withDefaults(
  defineProps<{
    value?: LayoutValue;
    maxCol?: number;
  }>(),
  {
    maxCol: 1,
  },
);

const emit = defineEmits<{
  (e: 'change', value: number): void;
}>();

const layouts = computed(() => {
  return [
    {
      col: 2,
      icon: `product-two-layout`,
    },
    {
      col: 1,
      icon: 'product-one-layout',
    },
  ];
});

const handleChangeLayout = (cols: number) => {
  emit('change', cols);
};
</script>

<template>
  <slot></slot>
  <div class="grid w-full grid-cols-2 gap-8">
    <div
      v-for="item in layouts"
      :key="item.col"
      class="rounded-medium grid max-w-full cursor-pointer gap-[2px] border border-transparent"
      :class="{
        'border-primary-300': item.col == value?.cols?.length,
      }"
      @click="handleChangeLayout(item.col)">
      <div class="rounded-medium bg-light-high flex h-[80px] items-center justify-center">
        <g-base-icon :name="item.icon" width="88px" height="48px" view-box="0 0 88 48"></g-base-icon>
      </div>
    </div>
  </div>
</template>
